import TexasSound from "../../texas_sound";

const {ccclass, property} = cc._decorator;

@ccclass
export  class ColorSliderComponent extends cc.Component {
    private green:cc.Color = null;
    private yellow:cc.Color = null;
    private red:cc.Color = null;

    private isDoAction:boolean[];

    private passTime:number;

    private timeSprite:cc.Sprite = null;

    private isStart:boolean = false;

    private totalTime:number = 0;//总时间

    private isSound:boolean = false;//是否播放音效

    private isPlayer:boolean = false;

    onLoad(){
        this.green = new cc.Color(100,255,75);
        this.yellow = new cc.Color(255, 236, 76);
        this.red = new cc.Color(255, 67, 67);
        this.timeSprite = this.node.getComponent(cc.Sprite);
    }

    //设置倒计时时间
    setOpTime(time:number,totalTime:number,isPlayer:boolean){
        if (totalTime <= 0) {
            this.hide();
            return;
        }
        this.show();
        this.isPlayer = isPlayer;
        this.isSound = false;
        this.timeSprite.node.active = true;
        this.timeSprite.fillStart = 0.25;
        this.timeSprite.node.color = cc.Color.GREEN;
        this.timeSprite.fillCenter = cc.v2(0.5,0.5);
        this.totalTime = totalTime;
        this.passTime = this.totalTime - time//已经过去的时间
        this.passTime = this.passTime < 0 ? 0:this.passTime;
        this.timeSprite.fillRange = -this.passTime / this.totalTime;
        this.setColor(this.passTime,this.node);
        this.isDoAction = [true,true,true]
    }

    update(delta:number){
        if (!this.isStart) {
            return;
        }
        this.scheduleColor(delta);
    }

    private scheduleColor(delta:number){
        this.passTime+=delta;
        let listTime = this.totalTime - this.passTime
        if (listTime >= 2.8 && listTime <= 3) {
            if (!this.isSound && this.isPlayer) {
                TexasSound.clockend();
                this.isSound = true;
            }
        }
        let range = this.passTime / this.totalTime;
        this.colorChangeAction(this.passTime,this.node);
        this.timeSprite.fillRange = -range
        if (range >= 1) {
            this.hide();
        }
    }

    hide(){
        this.node.active = false;
        this.isStart = false;
    }

    private show(){
        this.isStart = true;
        this.node.active = true;
    }

    private setColor(passTime:number,node:cc.Node){
        if (passTime <= this.totalTime * 0.5) {//绿色
            node.color = this.green;
        }else if (passTime <= this.totalTime * 0.75) {//yellow
            node.color = this.yellow;
        }else if(passTime <= this.totalTime){//剩下的1/4
            node.color = this.red;
        }
    }

    private colorChangeAction(passTime:number,node:cc.Node){
        if (passTime <= this.totalTime * 0.5) {//绿色
            if (this.isDoAction[0]) {
                let listTime = this.totalTime * 0.5 - passTime;
                let action = cc.tintTo(listTime,this.green.getR(), this.green.getG(), this.green.getB());
                 node.stopAllActions();
                node.runAction(action)
                this.isDoAction[0] = false;
            }
        }else if (passTime <= this.totalTime * 0.75) {//yellow
            if (this.isDoAction[1]) {
                let listTime = this.totalTime * 0.75 - passTime;
                let action = cc.tintTo(listTime,this.yellow.getR(), this.yellow.getG(), this.yellow.getB());
                node.stopAllActions();
                node.runAction(action)
                this.isDoAction[1] = false;
            }
    
        }else if(passTime <= this.totalTime){//剩下的1/4
            if (this.isDoAction[2]) {
                let listTime = this.totalTime - passTime;
                let action = cc.tintTo(listTime,this.red.getR(), this.red.getG(), this.red.getB());
                node.stopAllActions();
                node.runAction(action)
                this.isDoAction[2] = false;
            }
        }
    }
}
